const INITIALS_MAP = {
  "jensen-huang": "JH",
  "elon-musk": "EM",
  "jordi-visser": "JV",
  "matt-hougan": "MH",
  "anthony-pompliano": "AP",
  "gavin-baker": "GB",
  "michael-saylor": "MS",
  "alex-karp": "AK",
  "grain-of-salt": "GS",
  "james-invest-answers": "JI",
  "jeff-park": "JP",
  "dylan-leclair": "DL",
  "josh-mandell": "JM",
  "bitcoin-pharaoh": "BP",
  "scott-melker": "SM",
  "tillman-holloway": "TH",
  "andrew-parish": "AP2",
  "sanjay-mehrotra": "SM2",
};

function deriveInitials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "??";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const SIZE_CLASS = {
  xs: { box: "h-6 w-6", text2: "text-[9px]", text3: "text-[7px]" },
  sm: { box: "h-7 w-7", text2: "text-[10px]", text3: "text-[8px]" },
  md: { box: "h-9 w-9", text2: "text-[11px]", text3: "text-[9px]" },
  lg: { box: "h-12 w-12", text2: "text-sm", text3: "text-[11px]" },
  xl: { box: "h-16 w-16", text2: "text-base", text3: "text-sm" },
};

export default function InitialsAvatar({
  name,
  expertId,
  size = "md",
  className = "",
  ring = false,
}) {
  const initials =
    (expertId && INITIALS_MAP[expertId]) || deriveInitials(name);
  const cfg = SIZE_CLASS[size] || SIZE_CLASS.md;
  const textCls = initials.length >= 3 ? cfg.text3 : cfg.text2;
  return (
    <span
      data-testid={`avatar-${expertId || (name || "").toLowerCase().replace(/\s+/g, "-")}`}
      title={name}
      aria-label={name}
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-[#3b82f6]/40 bg-[#0b1120] font-mono font-semibold tracking-wider text-[#60a5fa] ${cfg.box} ${textCls} ${
        ring ? "ring-2 ring-[#111827]" : ""
      } ${className}`}
    >
      {initials}
    </span>
  );
}
